<template>
  <div>
    <bd-table-list
      :breadcrumb="breadcrumb"
      ref="resource"
      title="Mandats dont l'arrangement n'est pas respecté"
      subtitle="Recherche de mandats"
      autocomplete_idHistory="warrants"
      autocomplete_field="creancier.nom_soc || mandat.ID || mandat.arrangementID"
      bdTable="mandat_non_respecté"
      :actions="actions"
      :fields="fields"
      :Api="Api"
      @row-clicked="selectRow"
      @loaded="refreshRoute"
    >
      <template v-slot:menu>
        <b-row >
          <b-col lg="12">
            <b-button size="sm"  :disabled="busy" variant="secondary" class="mr-2" @click="printArr(null)"
              ><b-icon-printer-fill class="mr-2"></b-icon-printer-fill> R. ARR (Tous)
              <b-icon
                v-if="busy && type_rappel == null"
                icon="arrow-clockwise"
                animation="spin"
              ></b-icon
            ></b-button>
            <b-button :disabled="busy" variant="secondary" size="sm" class="mr-2" @click="printArr(1)"
              ><b-icon-printer-fill class="mr-2"></b-icon-printer-fill> R. ARR 1 <b-icon
                v-if="busy && type_rappel == 1"
                icon="arrow-clockwise"
                animation="spin"
              ></b-icon
            ></b-button
            >
            <b-button size="sm"  :disabled="busy" variant="secondary" class="mr-2" @click="printArr(2)"
              ><b-icon-printer-fill class="mr-2"></b-icon-printer-fill> R. ARR 2 <b-icon
                v-if="busy && type_rappel == 2"
                icon="arrow-clockwise"
                animation="spin"
              ></b-icon
            ></b-button
            >
            <b-button size="sm"  :disabled="busy" variant="secondary" class="mr-2" @click="printArr(3)"
              ><b-icon-printer-fill class="mr-2"></b-icon-printer-fill> R. ARR 3
              <b-icon
                v-if="busy && type_rappel == 3"
                icon="arrow-clockwise"
                animation="spin"
              ></b-icon
            ></b-button>
            <b-button :to="{ name: 'manageSettlementsInDefaultEmail'}" size="sm" icon :disabled="busy" variant="success" title="Mandats non respectés avec emails">
              <b-icon-envelope-fill></b-icon-envelope-fill>
            </b-button>
          </b-col>

        </b-row>
      </template>
      <template v-slot:cell(ID)="data">
        <b-link :to="{ name: 'warrantView', params: { id: data.item.ID } }">
          {{ data.item.ID }}
        </b-link>
      </template>
      <template v-slot:cell(realCreancier_nom_soc)="data">
        <b-link
          :to="{ name: 'creditorView', params: { id: data.item.creancierID } }"
        >
          {{ data.item.realCreancier_nom_soc }}
        </b-link>
      </template>
      <template v-slot:cell(debiteur)="data">
        <b-link
          :to="{ name: 'debtorView', params: { id: data.item.debiteurID } }"
        >
          {{ completeName(data.item) }}
        </b-link>
      </template>
      <template v-slot:cell(arrangementID)="data">
        <span
          v-if="
            data.item.arrangementIsLate == 'Yes' &&
            data.item.status == 'ouvert' &&
            data.item.arrangementID != 0
          "
        >
          <b-icon icon="exclamation-circle-fill" variant="danger"></b-icon>
        </span>
        <span
          v-else-if="
            data.item.status == 'ouvert' && data.item.arrangementID != 0
          "
        >
          <b-icon-check-circle-fill
            variant="success"
          ></b-icon-check-circle-fill>
        </span>
        <b-link
          v-if="data.item.arrangementID != 0"
          :to="{ name: 'settlement', params: { id: data.item.arrangementID } }"
        >
          {{ data.item.arrangementID }}
        </b-link>
        <span v-else>N/A</span>
      </template>
    </bd-table-list>
    <b-modal
      size="xl"
      :title="type_rappel == null ? 'Confirmation de tous les rappels' : 'Confirmation des rappels arrangement ' + type_rappel"
      id="confirm-rappels"
      hide-footer
      title-class="text-center"
    >
      <b-row>
        <b-col lg="3">
          <b-select
            v-model="type_envoi"
            :options="type_envoi_options"
          ></b-select>
        </b-col>
        <b-col>
          <b-button @click="confirm_rappels()" variant="success" class="mb-3"
            >Confirmer les rappels <b-icon
                v-if="busy_confirm"
                icon="arrow-clockwise"
                animation="spin"
              ></b-icon
            ></b-button
          >
        </b-col>
      </b-row>

      <object
        style="width: 100%; height: 1000px"
        :data="pdf_rappels"
        type="application/pdf"
      >
        <embed :src="pdf_rappels" type="application/pdf" />
      </object>
    </b-modal>
    
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
import gestion from "@/services/gestion.js";
export default {
  name: "ManageSettlementsInDefault",
  components: {
    BdTableList,
  },
  data() {
    return {
      Api: gestion.settlements_in_default,
      googleData: {},
      busy: false,
      busy_confirm: false,
      urlGoogleMaps: null,
      computeRoute: false,
      type_rappel: null,
      pdf_rappels: null,
      selectedWarrants: [],
      type_envoi: 2,
      type_envoi_options: [
        { value: 2, text: "Courrier" },
        { value: 4, text: "Email" },
        { value: 1, text: "Recommandé" },
        { value: 3, text: "Remise en main propre" },
      ],
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats dont l'arrangement n'est pas respecté",
          active: true,
        },
      ],
      actions: [
        {
          label: "Éditer",
          to: "warrantEdit",
          icon: "pencil-square",
          variant: "success"
        },
      ],
      fields: [
       {
          key: "ID",
          label: "#",
          sortable: true,
          class: "text-center",
          thStyle: { width: "100px" },
        },

        {
          key: "realCreancier_nom_soc",
          label: "Créancier",
          sortable: true,
          class: "text-truncate"
        },
        {
          key: "debiteur",
          label: "Débiteur",
          class: "text-truncate",
          sortable: true,
          formatter: (value, key, item) => {
            let a = "";
            if (item.nom_soc) {
              a += item.nom_soc;
            }
            if (item.nom && item.nom_soc) {
              a += " (" + item.prenom + " " + item.nom + ")";
            } else if (!item.nom_soc) {
              a += item.prenom + " " + item.nom;
            }
            return a;
          },
        },

        {
          key: "arrangementID",
          label: "Arr.",
          class: "text-center",
          sortable: true,
          thStyle: { width: "100px" },
        },
        {
          key: "negotiateurID",
          label: "Négo",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
        },
        {
          key: "arrangementLateAmount",
          label: "Retard",
          class: "text-right",
          sortable: true,
          thStyle: { width: "5%" },
          formatter: (value) => Number(value).toFixed(2) + " €",
        },
        {
          key: "arrangementDelayDaysTotal",
          label: "Retard",
          class: "text-center",
          thStyle: { width: "5%" },
          sortable: true,
          formatter: (value) => value + " j",
        },
        {
          key: "arrangementLateLevel",
          label: "Niveau de rappel",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
          formatter: (value) => {
            return "R. Arr. " + (value + 1);
          },
        },
        {
          key: "domiciliation",
          label: "Dom",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
          formatter: (value) => {
            switch (value) {
              case "oui":
                return `<i class="fad fa-check text-success"></i>`;
              default:
                return "";
            }
          },
        },
        {
          key: "sms",
          label: "SMS",
          class: "text-center",
          sortable: true,
          thStyle: { width: "5%" },
          formatter: (value) => {
            switch (value) {
              case "yes":
                return `<i class="fad fa-check text-success"></i>`;
              default:
                return "";
            }
          },
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width:100px",
        },
      ],
    };
  },
  methods: {
    completeName(item) {
      let a = "";
      if (item.nom_soc) {
        a += item.nom_soc;
      }
      if (item.nom && item.nom_soc) {
        a += " (" + item.prenom + " " + item.nom + ")";
      } else if (!item.nom_soc) {
        a += item.prenom + " " + item.nom;
      }
      return a;
    },
   
    selectRow(row) {
      //this.warrants[index]._rowVariant = 'success';
      this.urlGoogleMaps = null;
      const id = row.ID;
      this.$store.commit("toggleRoute", id);
      this.refreshRoute();

      //this.selectedWarrants = payload;
    },

    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
    confirm_rappels() {
      this.busy_confirm = true;
      warrants
        .confirm_reminders({
          type: this.type_rappel,
          envoi: this.type_envoi,
        })
        .then(() => {
          this.busy_confirm = false;
          this.$bvModal.hide('confirm-rappels')
        });
    },
    printArr(type) {
      this.busy = true;
      this.type_rappel = type;
      warrants
        .settlementsPDF({
          type: type,
        })
        .then((response) => {
          this.busy = false;
          if (response.data.success) {
            
            (this.pdf_rappels =
              this.$store.getters.url +
              "/upload/documents/rappels/" +
              response.data.pdf),
              this.$bvModal.show("confirm-rappels");
          }
        });
    },
  
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>